import { render, staticRenderFns } from "./i18n-icon.vue?vue&type=template&id=609f6be4&"
import script from "./i18n-icon.vue?vue&type=script&lang=js&"
export * from "./i18n-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports